export interface IframeConfig {
  proImagesUrl?: string;
  proMinLengthForImage?: number;
}

export const buildIframeUrl = (
  proNumber: string | undefined,
  configJSON: IframeConfig | undefined
): string | null => {
  if (!proNumber || !configJSON?.proImagesUrl) {
    return null;
  }

  try {
    const updatedProNumber = configJSON.proMinLengthForImage
      ? String(proNumber).padStart(configJSON.proMinLengthForImage, '0')
      : String(proNumber);
    
    return configJSON.proImagesUrl.replace('${0}', updatedProNumber);
  } catch (err) {
    console.error('Error building iframe URL:', err);
    return null;
  }
};

export const shouldShowCarrierImages = (iframeUrl: string | null): boolean => {
  return Boolean(iframeUrl);
};
